import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useInviteeSignUp } from 'hooks/useInviteeSignUp'
import { fetchEmailProvider } from 'actions/email_provider'
import {
  emailProviderLoadingSelector,
  emailProviderSettledSelector,
  emailProviderValueSelector,
} from 'selectors/email_provider'

export const MXRecordExperiment = ({ children }) => {
  const { encodedEmail: email } = useInviteeSignUp()
  const dispatch = useDispatch()
  const providerLoading = useSelector(emailProviderLoadingSelector)
  const emailProvider = useSelector(emailProviderValueSelector)
  const emailProviderSettled = useSelector(emailProviderSettledSelector)
  const shouldFetch = email && !emailProvider && !providerLoading && !emailProviderSettled

  useEffect(() => {
    if (shouldFetch) {
      dispatch(fetchEmailProvider(email))
    }
  }, [dispatch, email, shouldFetch])

  return children
}
